var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewInitial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Static-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resources-Catalogs",
    transform: "translate(-1242.000000, -593.000000)",
    stroke: "#3285C2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1243.000000, 594.194024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7828246,12 C6.92723732,12 3.33296244,9.97819353 0,5.9345806 C6.84872773,-1.97819353 14.0373003,-1.97819353 21.5657177,5.9345806 C19.2247685,9.4181106 14.8243992,12.0067681 10.7828246,12 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.7828246,
    cy: 5.9345806,
    r: 2.8696327
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewInitial);
export default __webpack_public_path__ + "static/media/preview_initial.e4824b48.svg";
export { ForwardRef as ReactComponent };